import PopupHeaderIcon from './component'

export default PopupHeaderIcon
